import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

// Bootstrap sr-only css class, found at https://a11y-guidelines.orange.com/en/web/components-examples/accessible-hiding/

export const screenReaderOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
export const ScreenReaderTitle = styled.h1<{
  as?: keyof HTMLElementTagNameMap;
  children: ReactNode;
}>`
  ${screenReaderOnly}
`;
